import React, { useState } from "react"
import { useI18next } from "gatsby-plugin-react-i18next"
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { LanguagePickerModal } from "./LanguagePickerModal"
import { getFormattedLanguage } from "../../util/languageUtil"
import { BodyTextRegular } from "../typography/text"

type Props = {
  className?: string
}

export const LanguagePickerSelector = ({ className }: Props) => {
  const { language } = useI18next()
  const [showModal, setShowModal] = useState(false)

  const openModal = () => {
    setShowModal(true)
  }

  const hideModal = () => {
    setShowModal(false)
  }

  return (
    <>
      <BodyTextRegular
        className={`text-foreground-base cursor-pointer hover:text-ctaMain ${
          className || ""
        }`}
        onClick={openModal}
      >
        <FontAwesomeIcon icon={solid("earth")} />{" "}
        {getFormattedLanguage(language)}
      </BodyTextRegular>
      <LanguagePickerModal hideModal={hideModal} isVisible={showModal} />
    </>
  )
}
